import { alertNoCalendarEntrySelected, isPrototype, locale, productIsParkTicket } from './global-variables'
import { initAmountInputs, resetAmountInputs } from './amount-input'
import { initLinksToAccordionDetails } from './accordion'
import { scrollToElement } from './scroll-to-element'
import { closeModal, closeModalOnClick, showModal } from './modal'
import { initPopover } from './popover'

const loadingSpinnerFullpage = document.querySelector('[data-js-loading-spinner-fullpage]')

export const initCalendarSheets = () => {
  const currentDateElement = document.querySelector('[data-js-calendar-current-date]')
  if (currentDateElement === null) {
    return
  }

  let touchstartX = 0
  let touchstartY = 0
  let touchendX = 0
  let touchendY = 0

  const pageWidth = window.innerWidth || document.body.clientWidth
  const swipeThreshold = Math.max(1, Math.floor(0.01 * (pageWidth)))
  const swipeLimit = Math.tan(((45 - 15) * Math.PI) / 180)
  const calendarElement = document.querySelector('[data-js-calendar]')
  const nextButton = document.querySelector('[data-js-calendar-next]')
  const prevButton = document.querySelector('[data-js-calendar-prev]')

  calendarElement.addEventListener('touchstart', function (event) {
    touchstartX = event.changedTouches[0].screenX
    touchstartY = event.changedTouches[0].screenY
  }, false)

  calendarElement.addEventListener('touchend', function (event) {
    touchendX = event.changedTouches[0].screenX
    touchendY = event.changedTouches[0].screenY

    if (handleGesture() === 'left') {
      nextButton.click()
    } else if (handleGesture() === 'right') {
      prevButton.click()
    }
  }, false)

  function handleGesture () {
    const x = touchendX - touchstartX
    const y = touchendY - touchstartY
    const yx = Math.abs(y / x)

    if (Math.abs(x) > Math.abs(y) && Math.abs(x) > swipeThreshold) {
      if (yx <= swipeLimit) {
        if (x < 0) {
          return 'left'
        } else {
          return 'right'
        }
      }
    }
  }

  const calendarSheetUrl = currentDateElement.dataset.jsCalendarUrl
  const calendarMaxDate = currentDateElement.dataset.jsMaxDate

  // @todo db: rewrite selector check to respect older browsers
  nextButton?.addEventListener('click', calendarGetSheetNext)

  prevButton?.addEventListener('click', calendarGetSheetPrev)

  window.addEventListener('popstate', function (event) {
    if (event.state && event.state.date) {
      calendarGetSheet(event, event.state.date)
    } else if (window.location.hash) {
      return false
    } else {
      const currentDate = currentDateElement.dataset.jsCalendarStartDate
      const dateParts = currentDate.split('-')
      const date = new Date(dateParts[0], dateParts[1] - 1)
      calendarGetSheet(event, date)
    }
  })

  function calendarGetSheetNext (event) {
    const currentDate = currentDateElement.dataset.jsCalendarCurrentDate
    const dateParts = currentDate.split('-')
    const date = new Date(dateParts[0], dateParts[1] - 1)
    date.setMonth(date.getMonth() + 1)

    calendarGetSheet(event, date, 'next')
  }

  function calendarGetSheetPrev (event) {
    const currentDate = currentDateElement.dataset.jsCalendarCurrentDate
    const dateParts = currentDate.split('-')
    const date = new Date(dateParts[0], dateParts[1] - 1)
    date.setMonth(date.getMonth() - 1)

    calendarGetSheet(event, date, 'prev')
  }

  function calendarGetSheet (event, date, direction = 'next') {
    const focusBefore = document.activeElement
    if (!isPrototype) {
      loadingSpinnerFullpage.removeAttribute('hidden')
      loadingSpinnerFullpage.focus()
      const ticketElement = document.querySelector('[data-js-product-id]')
      const ticketId = ticketElement.dataset.jsProductId
      const url = calendarSheetUrl + '?date=' + (date.getMonth() + 1) + '-' + date.getFullYear() + '&ticketId=' + ticketId + '&direction=' + direction

      fetch(url)
        .then(response => response.json())
        .then(function (data) {
          calendarElement.innerHTML = data.html
          const dateParts = data.date.split('-')
          const newDate = new Date(dateParts[0], dateParts[1] - 1)
          currentDateElement.innerText = newDate.toLocaleString(locale, { month: 'long', year: 'numeric' })
          currentDateElement.dataset.jsCalendarCurrentDate = newDate.getFullYear() + '-' + (newDate.getMonth() + 1)

          const newDateNumber = parseInt(newDate.getFullYear() + '' + (newDate.getMonth() < 10 ? '0' : '') + newDate.getMonth())
          const now = new Date()
          if (
            newDateNumber <= parseInt(now.getFullYear() + '' + (now.getMonth() < 10 ? '0' : '') + now.getMonth()) ||
            (direction === 'prev' && newDateNumber > parseInt(date.getFullYear() + '' + (date.getMonth() < 10 ? '0' : '') + date.getMonth()))
          ) {
            prevButton.setAttribute('disabled', 'disabled')
          } else {
            prevButton.removeAttribute('disabled')
          }

          if (calendarMaxDate) {
            const maxDateParts = calendarMaxDate.split('-')
            const maxDate = new Date(maxDateParts[0], maxDateParts[1] - 1)
            if (newDateNumber >= parseInt(maxDate.getFullYear() + '' + (maxDate.getMonth() < 10 ? '0' : '') + maxDate.getMonth())) {
              nextButton.setAttribute('disabled', 'disabled')
            } else {
              nextButton.removeAttribute('disabled')
            }
          }

          initCalendarEvents()

          if (!(event instanceof PopStateEvent)) {
            const windowLocation = window.location.pathname.replace(/\/\d{4}-\d{2}/, '')
            try {
              window.history.pushState({ newDate }, '', windowLocation + '/' + newDate.getFullYear() + '-' + (newDate.getMonth() < 9 ? '0' : '') + (newDate.getMonth() + 1))
            } catch (e) {
              // do nothing
            }
          }
        })
        .catch(function (data) {
          // @todo add error handling
          console.log('error')
          console.log(data)
        })
        .finally(function () {
          loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
          focusBefore.focus()
        })
    }
  }

  initCalendarEvents()
}

export const initCalendarEvents = () => {
  const calendarEntries = document.querySelectorAll('[data-js-select-day]')
  const replaceContentElement = document.querySelector('[data-js-replace-content]')
  const lowStockElements = document.querySelectorAll('[data-js-low-stock]')
  const alertSpecialEvent = document.querySelector('[data-js-special-alert]')
  const openingTimesElement = document.querySelector('[data-js-opening-time]')
  const alertReallySpecialEvent = document.querySelector('[data-js-really-special-alert]')

  const popoverButtons = document.querySelectorAll('[data-js-calendar-open-popover]')
  initPopover(popoverButtons)

  lowStockElements.forEach(entry => {
    entry.addEventListener('click', function () {
      calendarEntries.forEach(entry => {
        entry.setAttribute('aria-pressed', 'false')
      }, false)
      lowStockElements.forEach(entry => {
        entry.setAttribute('aria-pressed', 'false')
      }, false)
      this.setAttribute('aria-pressed', 'true')
      alertSpecialEvent.querySelector('p').innerHTML = this.dataset.jsAlertText
      alertSpecialEvent.removeAttribute('hidden')
      replaceContentElement.setAttribute('hidden', 'hidden')
      alertNoCalendarEntrySelected.setAttribute('hidden', 'hidden')

      scrollToElement(alertSpecialEvent, 300)
    })
  })

  calendarEntries.forEach(entry => {
    entry.addEventListener('click', function () {
      calendarEntries.forEach(entry => {
        entry.setAttribute('aria-pressed', 'false')
      }, false)
      lowStockElements.forEach(entry => {
        entry.setAttribute('aria-pressed', 'false')
      }, false)
      if (alertSpecialEvent) {
        alertSpecialEvent.setAttribute('hidden', 'hidden')
      }
      if (openingTimesElement) {
        openingTimesElement.setAttribute('hidden', 'hidden')
      }
      if (alertReallySpecialEvent) {
        alertReallySpecialEvent.setAttribute('hidden', 'hidden')
      }

      replaceContentElement.removeAttribute('hidden')

      if (!isPrototype) {
        loadingSpinnerFullpage.removeAttribute('hidden')
        loadingSpinnerFullpage.focus()
      }

      this.setAttribute('aria-pressed', 'true')

      if (!isPrototype) {
        const ticketElement = document.querySelector('[data-js-product-id]')
        const ticketId = ticketElement.dataset.jsProductId
        const url = ticketElement.dataset.jsTicketUrl
        const day = this.dataset.jsSelectDay

        fetch(url + '?ticketId=' + ticketId + '&day=' + day)
          .then(function (response) {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.json())
          .then(function (data) {
            replaceContentElement.innerHTML = data.html

            changeFieldVisibility(replaceContentElement)

            initAmountInputs()

            if (productIsParkTicket) {
              if (data.hint) {
                alertSpecialEvent.querySelector('p').innerHTML = data.hint
                alertSpecialEvent.removeAttribute('hidden')
              } else {
                alertSpecialEvent.setAttribute('hidden', 'hidden')
              }

              if (data.openingTimes && openingTimesElement) {
                openingTimesElement.querySelector('p').innerHTML = data.openingTimes
                openingTimesElement.removeAttribute('hidden')
              } else {
                openingTimesElement.setAttribute('hidden', 'hidden')
              }

              if (data.specialHint && alertReallySpecialEvent) {
                alertReallySpecialEvent.querySelector('p').innerHTML = data.specialHint
                alertReallySpecialEvent.removeAttribute('hidden')
              } else {
                alertReallySpecialEvent.setAttribute('hidden', 'hidden')
              }
            }

            initAddToCartButton()
            initLinksToAccordionDetails()

            if (typeof data === 'object' && data.datalayer && data.datalayer.length !== 0 && window.dataLayer) {
              window.dataLayer.push({ ecommerce: null })
              window.dataLayer.push(data.datalayer)
            }
          })
          .catch(function (data) {
            // @todo add error handling
            console.log('error')
            console.log(data)
          })
          .finally(function () {
            loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
            scrollToElement()
          })
      } else {
        const cartAmount = document.querySelector('[data-js-amount-cart]')
        changeFieldVisibility(cartAmount)
        resetAmountInputs()
        scrollToElement()
      }
    }, false)
  }, false)
}

export const initAddToCartButton = () => {
  let running = false
  const addToCartButton = document.querySelector('[data-js-add-to-cart]')

  addToCartButton.addEventListener('click', function (event) {
    const focusBefore = document.activeElement
    event.preventDefault()
    loadingSpinnerFullpage.removeAttribute('hidden')
    loadingSpinnerFullpage.focus()
    if (running) {
      return
    }

    running = true
    addToCartButton.setAttribute('disabled', 'disabled')
    const modal = document.querySelector('[data-js-add-to-cart-success]')
    closeModal(modal)

    const form = addToCartButton.closest('form')
    const url = form.action

    if (form.reportValidity() === false) {
      addToCartButton.removeAttribute('disabled')
      running = false
      loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
      focusBefore.focus()
      return
    }

    fetch(
      url,
      {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function (response) {
        if (!response.ok && response.status >= 500) {
          throw Error(response.statusText)
        }
        return response
      })
      .then(response => response.json())
      .then(function (data) {
        if (typeof data === 'object' && data.errors) {
          let errors = data.errors
          if (errors.errors) {
            errors = errors.errors
          }
          const failElement = document.querySelector('[data-js-add-to-cart-fail]')
          failElement.removeAttribute('hidden')
          failElement.querySelector('p').textContent = errors.join(' ')
          addToCartButton.removeAttribute('disabled')
        } else if (data.message && data.code && data.code === 429) {
          const failElement = document.querySelector('[data-js-add-to-cart-fail]')
          failElement.removeAttribute('hidden')
          failElement.querySelector('p').textContent = data.message
        } else {
          showModal(document.querySelector('[data-js-add-to-cart-success]'))
          document.querySelector('[data-js-add-to-cart-fail]').setAttribute('hidden', 'hidden')
          resetAmountInputs()

          closeModalOnClick(document.querySelector('[data-js-modal-close]'))
        }

        running = false
        loadingSpinnerFullpage.setAttribute('hidden', 'hidden')

        if (typeof data === 'object' && data.datalayer && data.datalayer.length !== 0 && window.dataLayer) {
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push(data.datalayer)
        }
      })
      .catch(function (data) {
        const failElement = document.querySelector('[data-js-add-to-cart-fail]')
        failElement.removeAttribute('hidden')

        running = false
        loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
        focusBefore.focus()
      })
  })
}

function changeFieldVisibility (replaceContentElement) {
  alertNoCalendarEntrySelected.setAttribute('hidden', 'hidden')

  const freeTicketForm = document.querySelector('[data-js-freeticket-form]')

  if (freeTicketForm) {
    freeTicketForm.removeAttribute('hidden')
  }

  if (replaceContentElement) {
    replaceContentElement.removeAttribute('hidden')
  }
}
